import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ToastrAlertComponent } from './components/toastr-alert/toastr-alert.component';
import { InitialsPipe } from './pipes/initials.pipe';
import { RandomColorPipe } from './pipes/random-color.pipe';
import { RemainingDaysPipe } from './pipes/remaining-days.pipe';
import { AddDaysPipe } from './pipes/add-days.pipe';
import { FormatDateFrPipe } from './pipes/format-date-fr.pipe';
import { ModalComponent } from './components/modal/modal.component';
import { LoaderComponent } from './components/loader/loader.component';
import { StateSectionComponent } from './components/state-section/state-section.component';

@NgModule({
  declarations: [
    // Components
    PaginationComponent,
    ToastrAlertComponent,
    ModalComponent,
    LoaderComponent,
    StateSectionComponent,
    // Pipes
    InitialsPipe,
    RandomColorPipe,
    RemainingDaysPipe,
    AddDaysPipe,
    FormatDateFrPipe,
  ],
  imports: [CommonModule, FormsModule],
  exports: [
    // Components
    ModalComponent,
    PaginationComponent,
    ToastrAlertComponent,
    LoaderComponent,
    StateSectionComponent,
    // Pipes
    InitialsPipe,
    RandomColorPipe,
    RemainingDaysPipe,
    AddDaysPipe,
    FormatDateFrPipe,
  ],
})
export class SharedModule {}
